
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104.27 131.54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ccc","d":"M4.23 5.13h89.83V126.4H4.23z"}}),_c('path',{attrs:{"fill":"#f2f2f2","d":"M0 11.224L89.128.012l15.136 120.321-89.127 11.212z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M31.389 26.884l50.502-6.353.187 1.488-50.502 6.353zM32.887 32.732L83.39 26.38l.188 1.489-50.502 6.353zM33.643 38.662l24.506-3.087.188 1.488L33.83 40.15zM34.382 50.655l50.502-6.353.187 1.488-50.502 6.353zM35.87 56.503l50.503-6.353.187 1.489-50.502 6.353zM36.64 62.432l24.507-3.087.187 1.488-24.506 3.087zM37.376 74.426l50.502-6.353.187 1.488-50.502 6.353zM38.864 80.274l50.502-6.353.187 1.489-50.502 6.353zM39.628 86.202l24.506-3.087.188 1.488-24.506 3.087zM40.36 98.197l50.501-6.353.187 1.488-50.502 6.353zM41.848 104.045l50.502-6.353.187 1.489-50.502 6.353zM42.624 109.952l24.507-3.087.187 1.488-24.506 3.087zM24.3 39.47l-11.14 1.4-1.4-11.14 11.14-1.4zm-10.49.57l9.66-1.22-1.22-9.66-9.66 1.2zm13.67 24.68l-11.14 1.4-1.4-11.14 11.14-1.4zm-10.49.57l9.66-1.22-1.22-9.65-9.66 1.22zm13.48 23.2l-11.14 1.4-1.4-11.14 11.14-1.4zm-10.49.57l9.66-1.22-1.22-9.65-9.66 1.17zm13.48 23.19l-11.14 1.4-1.4-11.14 11.14-1.4zm-10.49.57l9.66-1.22-1.22-9.65-9.65 1.22z"}})])
          )
        }
      }
    